module.exports = __webpack_public_path__ + "static/media/Eterno Fabric Storage Ottoman_Stone.a1e51000.png";